import { RelatedEntityModel } from '@models/relatedEntity'

import { useRelations } from '@hooks/useRelatedEntity'

import RelatedEntityListItem from '@components/RelatedEntityListItem'

import TemplatePage from './TemplatePage'

interface RelatedEntityProps {
  callbacks: {
    deleteRelatedEntity: () => void,
  },
  relatedEntity: RelatedEntityModel,
}

const RelatedEntity = (props: RelatedEntityProps) => {
  const { callbacks: { deleteRelatedEntity }, relatedEntity } = props

  const { subject } = useRelations(relatedEntity)

  if (subject.type === 'TemplatePage'){
    return (
      <TemplatePage
        callbacks={{ deleteRelatedEntity }}
        relatedEntity={relatedEntity}
        templatePage={subject}
      />
    )
  }

  return <RelatedEntityListItem callbacks={{ deleteRelatedEntity }} relatedEntity={relatedEntity} subject={subject} />
}

export default RelatedEntity
